/**
 * 前端校验工具函数
 * @author Sky
 */
// 用户名校验
export function isvalidUsername (str) {
  const reg = /^[a-z]\w{2,31}$/
  return reg.test(str)
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 校验用户名英文汉字
export function isCnEnName (_name) {
  const regName = /^[a-zA-Z\u4e00-\u9fa5]+$/
  return regName.test(_name)
}

/**
 * 校验 email
 * @param email
 * @returns {boolean}
 */
export function validateEmail (email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * 手机号
 * @param str
 * @returns {boolean}
 */
export function isvalidMobile (str) {
  const reg = /^((1[3-9]))\d{9}$/
  return reg.test(str)
}

/**
 * 长度20字符
 * @param str
 * @returns {boolean}
 */
export function isLange (str) {
  const reg = /^.{1,20}$/
  return reg.test(str)
}

/**
 * 长度50字符
 * @param str
 * @returns {boolean}
 */
export function isNameLange (str) {
  const regNameLength = /^.{1,50}$/
  return regNameLength.test(str)
}

/*
*   去除左右空格
* */
export function trimString (s) {
  return s.replace(/(^\s*)|(\s*$)/g, '')
}
